<template>
  <!--
    Renders sanitized markdown produced by `markdown.js`. The renderer
    escapes raw HTML and only allows http(s)/mailto/same-origin link hrefs,
    so v-html is safe for our own LLM output. Both chat and CLI message
    components mount this — the .ai-md class is the styling hook each
    parent scopes locally.
  -->
  <div
    class="ai-md"
    v-html="html"
  />
</template>

<script>
import { renderMarkdown } from './markdown'

export default {
  name: 'RenderedAnswer',

  props: {
    text: {
      type: String,
      default: ''
    }
  },

  computed: {
    html() {
      return renderMarkdown(this.text || '')
    }
  }
}
</script>
